<template>
  <div class="container">
    <transition-group name="fade" mode="out-in">
      <layout v-show="pageIsLoaded" :key="1"></layout>
      <preloader v-if="!pageIsLoaded" :key="2"></preloader>
    </transition-group>
  </div>
</template>

<script>
  import { EventBus } from './main.js';

  export default {

    data: () => ({
      pageIsLoaded: false
    }),
    created() {
      EventBus.$on('pageLoaded', () => {
        setTimeout(() => {
          this.pageIsLoaded = true
        }, 500)
      })
    }

  }


</script>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to
  /* .fade-leave-active below version 2.1.8 */

  {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/app.vue